class ProductRecommendations extends TRYComponent {
  #ac = null;

  connectedCallback() {
    super.connectedCallback();
    const track = this.querySelector('[data-track]');
    if (!track) return;
    this.#ac = new AbortController();
    dragScroll(track, this.#ac.signal);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#ac?.abort();
  }
}

customElements.define('product-recommendations', ProductRecommendations);
